module.exports = __webpack_public_path__ + "static/media/patient-care-icon_2-color.042b030b.svg";